import { AIS_LINK_SOURCE_KEY, isAisLinkPage } from './aisSignin';

let captured = '';

export const tokenOf = (hash: string) => new URLSearchParams(hash.slice(1)).get('token') ?? '';

// Runs before telemetry starts, which records the page URL: the token must be gone from it by then
export const captureAisLinkToken = () => {
  if (!isAisLinkPage()) return;
  captured = tokenOf(window.location.hash);
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
};

export const takeAisLinkToken = (): string => {
  const token = captured || tokenOf(window.location.hash);
  captured = '';
  return token;
};

// the reload's referrer is labrador-ui itself, so the open tab leaves the vendor's origin for this one link
export const leaveLinkSource = (origin: string, token: string) =>
  sessionStorage.setItem(AIS_LINK_SOURCE_KEY, JSON.stringify({ origin, token }));

export const takeLeftLinkSource = (token: string): string => {
  const marker = sessionStorage.getItem(AIS_LINK_SOURCE_KEY);
  sessionStorage.removeItem(AIS_LINK_SOURCE_KEY);
  try {
    const left = JSON.parse(marker ?? '') as { origin?: unknown; token?: unknown };
    return left.token === token && typeof left.origin === 'string' ? left.origin : '';
  } catch {
    return '';
  }
};
